import { Button } from "@/components/ui/button";
export default function StayUpdated() {
  return <section data-section-id="228408" id="get-in-touch" className="bg-background text-foreground relative py-24 md:py-32 flex flex-col items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-40 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px)] bg-[size:20px_100%]" aria-hidden="true" />

      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center">
        <p className="font-default text-3xl md:text-4xl font-bold tracking-tight text-center mb-8 text-primary">
          Need Support?
        </p>
        
        <Button asChild size="lg" className="rounded-lg font-default font-semibold tracking-wide px-10 py-7 text-base bg-primary text-primary-foreground hover:bg-primary/90 shadow-md transition-colors duration-300">
          <a href="mailto:support@thebarndesk.com">
            Contact Our Team
          </a>
        </Button>
      </div>
    </section>;
}